<div class="modal-header">
  <h3 class="modal-title" >{{title}}</h3>
  <button type="button" class="btn-close" (click)="closeModal()" aria-label="Close"></button>
</div>
<div class="modal-body">
  <div class="col row mb-3">
    <label class="form-label col-12 align-self-center">{{titleName}}:</label>
    <div class="col-12">
      <input class="form-control" type="text" placeholder="-- โปรดระบุ --" [(ngModel)]="name" />
    </div>
    <p class="text-danger mt-1" *ngIf="requiredName">* โปรดกรอก</p>
  </div>
  <div class="col row mb-3" *ngIf="titleName2">
    <label class="form-label col-12 align-self-center">{{titleName2}}:</label>
    <div class="col-12">
      <input class="form-control" type="text" placeholder="-- โปรดระบุ --" [(ngModel)]="code" />
    </div>
    <p class="text-danger mt-1" *ngIf="requiredCode">* โปรดกรอก</p>
  </div>

  <div class="col row mb-3" *ngIf="titleCountUnit">
    <label class="form-label col-12 align-self-center">{{titleCountUnit}}:</label>
    <div class="col-12">
      <input class="form-control" type="text" placeholder="-- โปรดระบุ --" [(ngModel)]="countUnit" />
    </div>
  </div>

  <div class="col row">
    <div class="col-lg-12 col-xs-12">
      <label for="isActive" class="form-label">สถานะการใช้งาน</label>
      <div class="form-check form-switch">
        <input class="form-check-input" type="checkbox" id="isActive" [(ngModel)]="status"/>
        <label for="isActive" *ngIf="status"
               class="form-check-label">เปิดใช้งาน</label>
        <label for="isActive" *ngIf="!status"
               class="form-check-label">ปิดการใช้งาน</label>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-success" (click)="onSave()">บันทึก</button>
  <button type="button" class="btn btn-danger" (click)="closeModal()">ยกเลิก</button>
</div>
